import React from 'react'

import { toSafeHttpUrl } from '@/lib/helpers/helperFunctions'

interface Props {
  title: string
  /** A company-entered booking link, which may not be a safe URL. */
  url?: string | null
  height: string
}

/**
 * Embeds a company's (non-Calendly) booking page. Renders nothing unless the
 * link is http(s), and sandboxes the frame so the page can't reach into RQ.
 */
const SafeBookingIframe: React.FC<Props> = ({ title, url, height }) => {
  const safeUrl = toSafeHttpUrl(url)

  if (!safeUrl) {
    return null
  }

  return (
    <iframe
      title={title}
      src={safeUrl}
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups allow-popups-to-escape-sandbox"
      referrerPolicy="strict-origin-when-cross-origin"
      width="100%"
      height={height}
    ></iframe>
  )
}

export default SafeBookingIframe
